"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = canSubmit;

var _lodash = _interopRequireDefault(require("lodash.get")),
    TEAM_TYPE = "TEAM",
    SHARE_TYPE = "SHARE",
    UNLIMITED = -1;

function canSubmit(_ref) {
  var orgCreditInfo = _ref.orgCreditInfo,
      teamCreditInfo = _ref.teamCreditInfo,
      selectedTeamId = _ref.selectedTeamId,
      _orgCreditInfo$packag = orgCreditInfo["package"];
  _orgCreditInfo$packag = void 0 === _orgCreditInfo$packag ? {} : _orgCreditInfo$packag;
  var creditType = _orgCreditInfo$packag.creditType,
      videoQuantity = _orgCreditInfo$packag.videoQuantity,
      _orgCreditInfo$credit = orgCreditInfo.creditBalance;
  _orgCreditInfo$credit = void 0 === _orgCreditInfo$credit ? {} : _orgCreditInfo$credit;
  var balance = _orgCreditInfo$credit.balance,
      rolloverBalance = _orgCreditInfo$credit.rolloverBalance;
  if (creditType === SHARE_TYPE && videoQuantity === UNLIMITED) return !0;
  if (creditType === SHARE_TYPE && !(balance + rolloverBalance)) return !1;
  if (creditType === TEAM_TYPE && !teamCreditInfo.length) return !1;
  var teamCredit = 0 < teamCreditInfo.length ? teamCreditInfo.find(function (_ref2) {
    var team = _ref2.team;
    return team.teamId === selectedTeamId;
  }) : void 0,
      teamCreditBalance = (0, _lodash["default"])(teamCredit, "team.creditBalance", {
    balance: 0,
    rolloverBalance: 0
  }),
      totalTeamBalance = teamCreditBalance.balance + teamCreditBalance.rolloverBalance;
  return !!(creditType !== TEAM_TYPE || totalTeamBalance);
}